import { ChangeDetectorRef, Component, viewChild } from '@angular/core';
import { Asset, DataProtection, DataProtectionInput } from '../../../../generated/generated-types';
import { WidgetAssetsManagerComponent } from '../../../asset/widget-assets-manager/widget-assets-manager.component';

import { CommonModule } from '@angular/common';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { AssetFileInputComponent } from '../../../../shared/components/asset-file-input/asset-file-input.component';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { NotificationService } from '../../../../@core/services/notification/notification.service';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { AssetService } from '../../../asset/services/asset.service';
import { WidgetAssetListComponent } from '../../../products/components/widget-asset-list/widget-asset-list.component';
import { DataProtectionService } from '../../services/data-protection.service';

@Component({
  selector: 'app-widget-data-protection-assets-manager',
  templateUrl: './widget-data-protection-assets-manager.component.html',
  standalone: true,
  imports: [
    WidgetAssetListComponent,
    AssetFileInputComponent,
    CommonModule,
  ]
})
export class WidgetDataProtectionAssetsManagerComponent extends WidgetAssetsManagerComponent<DataProtection> {

  assetListRef = viewChild<WidgetAssetListComponent>('assetList');

  isSaving: boolean = false;

  constructor(
    /** Needs to Implement IBaseModelAssetService */
    public dataProtectionService: DataProtectionService,
    public assetService: AssetService,
    public notificationService: NotificationService,
    public i18n: I18nService,
    private cdRef: ChangeDetectorRef

  ) {
    super(dataProtectionService, assetService, notificationService, i18n);

    // this.setSelectedItemAsFeature = this.setSelectedItemAsFeature.bind(this);

    this.assetsAdded.subscribe(x => {
      this.model.assets = this.model.assets.concat(x);// trigger change detection
    });
  }

  async setSelectedItemAsFeature() {

    let selectedItems: Asset[] = this.assetListRef().selectedItems();

    if (selectedItems.length > 0) {
      let updateDataProtection: DataProtectionInput = {
        id: this.model.id,
        featuredAssetId: selectedItems[0].id
      }

      await this.dataProtectionService.saveItem(updateDataProtection);
      this.notificationService.success(_("common.save-successful"));
    }

  }

  checkIfCanSave() {
    let component = this.options.formState.detailComponent as BaseDetailComponent<DataProtection>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode() {

    //Other options would be to use the service, but special overwrite in the component wont be used then

    let component = this.options.formState.detailComponent as BaseDetailComponent<DataProtection>;
    if (!component) {
      console.error("No detail component found to save Asset");
      return;
    }

    this.isSaving = true;
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving = false;
    this.cdRef.detectChanges();
  }

}
